import {FunctionComponent, ReactNode, useEffect} from "react";
import {LanguageType, LanguageValues} from "types/LanguageType";
import { LanguageContext } from "contexts/LanguageContext";

const LanguageContextProvider: FunctionComponent<{
    language?: LanguageType;
    children?: ReactNode;
}> = ({ language = 'el', children }) => {
    useEffect(()=>{
        if(!LanguageValues.includes(language))
            throw new Error('Invalid language param value on LanguageContextProvider');
    }, [language])
    return (
        <LanguageContext.Provider value={language}>
            {children}
        </LanguageContext.Provider>
    )
};
export default LanguageContextProvider